import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, LoadingController, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from 'src/app/services/config/config';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { format, isBefore, isEqual, parse, parseISO } from 'date-fns'
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ProverDatepickerComponent } from 'src/app/components/prover-datepicker/prover-datepicker';
import { ProverHorasComponent } from 'src/app/components/prover-horas/prover-horas.component';

@Component({
  selector: 'app-grupo-add-reuniao',
  templateUrl: './grupo-add-reuniao.page.html',
  styleUrls: ['./grupo-add-reuniao.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    DateFormatPipe,
    TranslateModule,
    ProverDatepickerComponent,
    ProverHorasComponent
  ],
})
export class GrupoAddReuniaoPage implements OnInit {
  validations_form: FormGroup;
  idGrupo: string = "";
  idReuniao: string = "";
  readOnly: boolean = false;
  tipos: any = [];
  validation_messages = {
    'responsavel': [
      { type: 'required', message: this.translate.instant('O responsável deve ser informado') }
    ],
    'tema': [
      { type: 'required', message: this.translate.instant('O tema deve ser informado') }
    ],
    'data': [
      { type: 'required', message: this.translate.instant('A data deve ser informada') }
    ],
    'horaInicio': [
      { type: 'required', message: this.translate.instant('A hora início deve ser informada') }
    ],
    'horaFim': [
      { type: 'required', message: this.translate.instant('A hora fim deve ser informada') }
    ]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public grupoProvider: GrupoProvider,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private translate: TranslateService,
    public configProvider: ConfigProvider) {
    this.idGrupo = navParams.get('idGrupo');
    this.idReuniao = navParams.get('idReuniao');
    this.readOnly = this.navParams.get('readOnly');
    this.grupoProvider.getTiposReuniao().subscribe((data) => {
      this.tipos = data;
    });

    this.validations_form = this.formBuilder.group({
      responsavel: new FormControl('', Validators.required),
      tema: new FormControl('', Validators.required),
      data: new FormControl(format(new Date(), 'yyyy-MM-dd'), Validators.required),
      horaInicio: new FormControl(format(new Date(), 'HH:mm'), Validators.required),
      horaFim: new FormControl(format(new Date(), 'HH:mm'), Validators.required),
      observacao: new FormControl('', Validators.nullValidator),
      idProjetoTipo: new FormControl(7),
    });

    if (this.idReuniao) {
      this.carregarForm();
    }

  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async onSubmit(reuniao: { idGrupo: string; id: string; dataInicio: string; data: string; horaInicio: string; horaFim: string; }) {
    reuniao.idGrupo = this.idGrupo;
    reuniao.horaInicio = format(parse(reuniao.horaInicio, 'HH:mm', new Date()), 'HH:mm');
    reuniao.horaFim = format(parse(reuniao.horaFim, 'HH:mm', new Date()), 'HH:mm');

    const inicio = parse(reuniao.horaInicio, 'HH:mm', new Date(1970,0,1));
    const fim = parse(reuniao.horaFim, 'HH:mm', new Date(1970,0,1));
    const result = isBefore(inicio, fim) || isEqual(inicio, fim);
    if (!result) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("O hórario informado não atendem aos critérios de validação."),
        duration: 3000,
      });

      toast.present();
      return;
    }

    if (this.idReuniao) {
      reuniao.id = this.idReuniao;
    }

    this.grupoProvider.criarReuniao(reuniao).subscribe(async () => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Reunião salva com sucesso!'),
        duration: 3000
      });

      toast.present();
      reuniao.dataInicio = reuniao.data + ' ' + reuniao.horaInicio + ':00';

      this.modalCtrl.dismiss(reuniao);
    })
  }

  carregarForm() {
    this.grupoProvider.getReuniao(this.idReuniao).subscribe(res => {
      this.validations_form.controls['responsavel'].setValue(res.responsavel);
      this.validations_form.controls['tema'].setValue(res.tema);
      this.validations_form.controls['observacao'].setValue(res.observacao);
      this.validations_form.controls['idProjetoTipo'].setValue(String(res.idProjetoTipo));
      this.validations_form.controls['data'].setValue(format(parseISO(res.data), 'yyyy-MM-dd'));
      this.validations_form.controls['horaInicio'].setValue(format(parse(res.horaInicio, 'HH:mm', new Date()), 'HH:mm'));
      this.validations_form.controls['horaFim'].setValue(format(parse(res.horaFim, 'HH:mm', new Date()), 'HH:mm'));
    });
  }
}
